import { defineComponent, computed } from "vue";
import { u as useColors } from "../../../composables/useColors-cd2c0b98.mjs";
import { u as useTextColor } from "../../../composables/useTextColor-19f6bd95.mjs";
const _sfc_main = defineComponent({
  name: "VaDatePickerCell",
  props: {
    otherMonth: { type: Boolean, default: false },
    today: { type: Boolean, default: false },
    inRange: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    weekend: { type: Boolean, default: false },
    hidden: { type: Boolean, default: false },
    focused: { type: Boolean, default: false },
    highlightWeekend: { type: Boolean, default: false },
    highlightToday: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    color: { type: String, default: "primary" }
  },
  emits: ["click"],
  setup(props, { emit }) {
    const onClick = () => {
      if (!props.disabled) {
        emit("click");
      }
    };
    const { getColor } = useColors();
    const bg = computed(() => getColor(props.color));
    const { textColorComputed } = useTextColor(bg);
    return {
      bg,
      onClick,
      textColorComputed
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaDatePickerCell.vue_vue_type_script_lang-7b8c6cd0.mjs.map
